<template>
  <main class="font-sans antialiased">
    <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  </main>
</template>
